import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["children", "style"],
  _excluded2 = ["value", "keyName", "indentWidth", "renderKey", "renderValue", "renderBraces", "enableClipboard", "displayObjectSize", "displayDataTypes"],
  _excluded3 = ["children", "color", "fontSize", "opacity", "paddingRight", "style"];
import { Fragment, forwardRef, useState } from 'react';
import { Meta, CountInfo } from './node';
import { Copied } from './copied';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Line = props => /*#__PURE__*/_jsx("div", _extends({}, props));
var isFloat = n => Number(n) === n && n % 1 !== 0 || isNaN(n);
export var typeMap = {
  string: {
    color: 'var(--w-rjv-type-string-color, #cb4b16)',
    label: 'string'
  },
  number: {
    color: 'var(--w-rjv-type-int-color, #268bd2)',
    label: 'int'
  },
  float: {
    color: 'var(--w-rjv-type-float-color, #859900)',
    label: 'float'
  },
  bigint: {
    color: 'var(--w-rjv-type-bigint-color, #268bd2)',
    label: 'bigint'
  },
  boolean: {
    color: 'var(--w-rjv-type-boolean-color, #2aa198)',
    label: 'bool'
  },
  date: {
    color: 'var(--w-rjv-type-date-color, #586e75)',
    label: 'date'
  },
  null: {
    color: 'var(--w-rjv-type-null-color, #d33682)',
    label: 'null'
  },
  NaN: {
    color: 'var(--w-rjv-type-nan-color, #859900)',
    label: 'NaN'
  },
  undefined: {
    color: 'var(--w-rjv-type-undefined-color, #586e75)',
    label: 'undefined'
  }
};
export var Colon = _ref => {
  var {
      children = ':',
      style
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", _extends({
    className: "w-rjv-colon",
    style: _extends({
      paddingRight: 3
    }, style)
  }, props, {
    children: children
  }));
};
export function ValueView(props) {
  var _typeMap$type;
  var {
      value,
      indentWidth,
      renderKey,
      renderValue,
      renderBraces,
      enableClipboard,
      displayObjectSize,
      displayDataTypes
    } = props,
    reset = _objectWithoutPropertiesLoose(props, _excluded2);
  var type = typeof value;
  var content = '';
  var color = '';
  var style = {};
  if (typeof value === 'number') {
    type = isFloat(value) ? 'float' : 'number';
    content = value.toString();
  }
  if (typeof value === 'boolean') {
    type = 'boolean';
    content = value.toString();
  }
  if (typeof value === 'object' && value instanceof Date) {
    type = 'date';
    content = value.toString();
  }
  var typeView = /*#__PURE__*/_jsx(Type, {
    type: type
  });
  if (value === null) {
    type = 'null';
    content = ("" + value).toLocaleUpperCase();
    typeView = /*#__PURE__*/_jsx(Fragment, {});
    style = {
      fontWeight: 'bold'
    };
  }
  if (value === undefined) {
    type = 'undefined';
    content = String(value);
    typeView = /*#__PURE__*/_jsx(Fragment, {});
  }
  if (typeof value === 'bigint') {
    type = 'bigint';
    content = value + "n";
  }
  if (typeof value === 'string') {
    content = "\"" + value + "\"";
  }
  if (!displayDataTypes) {
    typeView = /*#__PURE__*/_jsx(Fragment, {});
  }
  color = ((_typeMap$type = typeMap[type]) == null ? void 0 : _typeMap$type.color) || '';
  var [showTools, setShowTools] = useState(false);
  var tools = enableClipboard ? /*#__PURE__*/_jsx(Copied, {
    show: showTools,
    text: value
  }) : undefined;
  var eventProps = {
    className: 'w-rjv-line',
    style: {
      paddingLeft: indentWidth
    }
  };
  if (enableClipboard) {
    eventProps.onMouseEnter = () => setShowTools(true);
    eventProps.onMouseLeave = () => setShowTools(false);
  }
  if (content && typeof content === 'string') {
    var reView = renderValue && renderValue({
      className: 'w-rjv-value',
      style: _extends({
        color
      }, style),
      type,
      content,
      children: value
    });
    var valueView = reView ? reView : /*#__PURE__*/_jsx(Label, {
      color: color,
      style: style,
      className: "w-rjv-value",
      children: content
    });
    return /*#__PURE__*/_jsx(Line, _extends({}, eventProps, {
      children: /*#__PURE__*/_jsxs(Label, _extends({}, reset, {
        ref: null,
        children: [renderKey, /*#__PURE__*/_jsx(Colon, {}), typeView, valueView, tools]
      }))
    }));
  }
  var length = Array.isArray(value) ? value.length : Object.keys(value).length;
  var empty = /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Meta, {
      render: renderBraces,
      start: true,
      isArray: Array.isArray(value)
    }), /*#__PURE__*/_jsx(Meta, {
      render: renderBraces,
      isArray: Array.isArray(value)
    }), displayObjectSize && /*#__PURE__*/_jsxs(CountInfo, {
      children: [length, " items"]
    })]
  });
  return /*#__PURE__*/_jsx(Line, _extends({}, eventProps, {
    children: /*#__PURE__*/_jsxs(Label, _extends({}, reset, {
      ref: null,
      children: [renderKey, /*#__PURE__*/_jsx(Colon, {}), typeView, empty, tools]
    }))
  }));
}
export var Label = /*#__PURE__*/forwardRef((_ref2, ref) => {
  var {
      children,
      color,
      fontSize,
      opacity,
      paddingRight,
      style
    } = _ref2,
    reset = _objectWithoutPropertiesLoose(_ref2, _excluded3);
  return /*#__PURE__*/_jsx("span", _extends({
    style: _extends({
      color,
      fontSize,
      opacity,
      paddingRight
    }, style)
  }, reset, {
    ref: ref,
    children: children
  }));
});
export var Type = props => {
  var _typeMap$type2, _typeMap$type3;
  var {
    type
  } = props;
  var color = (_typeMap$type2 = typeMap[type]) == null ? void 0 : _typeMap$type2.color;
  var label = (_typeMap$type3 = typeMap[type]) == null ? void 0 : _typeMap$type3.label;
  if (color && label) {
    return /*#__PURE__*/_jsx(Label, {
      color: color,
      fontSize: 11,
      opacity: 0.8,
      paddingRight: 4,
      className: "w-rjv-type",
      "data-type": type,
      children: label
    });
  }
};